import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

// import addCookieWithConsent from '../../utilities/addCookieWithConsent';
import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

// import {
  
// } from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Shared search
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetSearch = packet => {
  return {
    type: 'REQUEST_GET_SEARCH',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetSearchSuccess = data => ({
  type: 'RECEIVE_GET_SEARCH_SUCCESS',
  data
})

export const receiveGetSearchFail = data => ({
  type: 'RECEIVE_GET_SEARCH_FAIL',
  data
})

export const tryToGetSearch = packet => (dispatch, getState) => {

  dispatch(requestGetSearch(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/shared/search/?' + new URLSearchParams(packet), {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetSearchSuccess({
        request: packet,
        response: json
      }));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetSearchFail({errors:e, lastSubmit: packet}));
    })
}
